import React, { FC, useState, useEffect } from 'react';
import useDeepCompareEffect from 'use-deep-compare-effect';
import { injectIntl, IntlShape } from 'react-intl';
import { Grid } from '@material-ui/core';
import { isEmpty, get, cloneDeep } from 'lodash';
import { createStructuredSelector } from 'reselect';
import { connect, useSelector } from 'react-redux';
import LegalProceedingTabs from 'components/LegalProceedingTabs';
import {
  requestGetExpertiseRaport,
  requestGetJudgementAdd,
} from 'containers/LawyerLegalProceedingsPage/actions';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import {
  Container,
  Content,
  StyledDiv,
} from 'containers/ExpertExpertise/ConcernedExpertise/style';
import { translate } from 'containers/services/translate';
import messages from 'containers/ExpertExpertise/ConcernedExpertise/messages';
import ExpertiseIcon from 'components/SahamIcons/ExpertiseIcon';
import RefuseButton from 'components/Buttons/RefuseButton';
import PrimaryButton from 'components/Buttons/PrimaryButton';
import { BUTTON_COLORS } from 'constants/design';
import {
  EXPERTISE_INIT_STATE,
  MISSION_EXPERTISE_VICTIM_TYPE,
  MISSION_NATURE,
} from 'containers/ExpertExpertise/ConcernedExpertise/constants';
import {
  makeSelectDocument,
  makeSelectDocumentId,
} from 'containers/UploadDocuments/selectors';
import {
  uploadDocument,
  resetUploadDocumentStore,
} from 'containers/UploadDocuments/actions';
import { IUploadedDocument } from 'containers/LawyerLegalProceedingsPage/typings';
import {
  shouldDisplayActionButton,
  renderFilterExpertiseTypeByMissionExpertise,
  renderFilterConcernedPartyTypeByMissionExpertise,
} from 'containers/ExpertExpertise/ConcernedExpertise/utils';
import ActionButton from 'containers/ExpertExpertise/ActionButton';
import {
  requestCreateMissionPostPone,
  requestRejectMission,
  requestUpdateMissionExpertise,
  requestUpdateMissionPostPone,
} from 'containers/ExpertExpertise/actions';
import NoticeDeficiencyDialog from 'containers/ExpertExpertise/Dialogs/NoticeDeficiencyDialog';
import RecapNoticeDeficiency from 'containers/ExpertExpertise/Recap/RecapNoticeDeficiency';
import RejectMissionDialog from 'containers/ExpertExpertise/Dialogs/RejectMissionDialog';
import PostPoneExpertise from 'containers/ExpertExpertise/Dialogs/PostPoneExpertiseDialog';
import RecapPostPoneExpertise from 'containers/ExpertExpertise/Recap/RecapPostPoneExpertise';
import ConcernedExpertiseForm from 'containers/ExpertExpertise/ConcernedExpertise/ConcernedExpertiseForm';
import { MISSION_EXPERISE_VICTIM_STATUS } from 'containers/data-structure';
import Recap from 'containers/ExpertExpertise/ConcernedExpertise/Recap';
import { PROCEDURE_TYPES } from 'containers/LawyerLegalProceedingsPage/constants';
import JudiciaryExpertise from 'containers/ExpertExpertise/JudiciaryExpertise';
import { configToItems } from 'containers/ExpertExpertise/FillExpertise/utils';
import { VictimType } from 'typings/globalTypes';

export interface ConcernedExpertiseProps {
  intl: IntlShape;
  uploadedDocument: IUploadedDocument;
  documentIdStore: string;
  victim: VictimType;
  requestCreateVictimExpertise: Function;
  mission: any;
  vehicle: any;
  expertiseVictim: any;
  missionPostPone: any;
  sagis_code: any;
  uploadDocument: Function;
  resetUploadDocumentStore: Function;
  requestCreateMissionPostPone: Function;
  missionPostPoneExpertise: any;
  requestUpdateMissionExpertise: Function;
  requestUpdateMissionPostPone: Function;
  requestRejectMission: Function;
  requestGetExpertiseRaport: Function;
  requestGetJudgementAdd: Function;
  sagisVictimInfo: any;
  sagisOpposingParties: any;
  requestGetDocByDocumentumId: Function;
  claimNumber: string;
  lossDate: Date;
}

const ConcernedExpertise: FC<ConcernedExpertiseProps> = (
  props,
): JSX.Element => {
  const { victim, vehicle } = props;
  const currentTabIndex = 0;
  const [dropDown, setDropDown] = React.useState<null | HTMLElement>(null);
  const [openNoticeDeficiencyDialog, setOpenNoticeDeficiencyDialog] = useState(
    false,
  );
  const [openRejectMissionDialog, setOpenRejectMissionDialog] = useState(false);
  const [
    openPostPoneExpertiseDialog,
    setOpenPostPoneExpertiseDialog,
  ] = useState(false);
  const [consultingExpertise, setConsultingExpertise] = useState(null);
  const [allConsultinExpertise, setAllConsultinExpertise] = useState([]);
  useEffect(() => {
    if (
      get(props.mission, 'nature') != MISSION_NATURE.TRANSACTION &&
      get(props.mission, 'nature') != MISSION_NATURE.PROVISIONAL_JUDICIARY
    ) {
      props.requestGetExpertiseRaport(
        props.mission?.claimId,
        props.mission?.step == 1
          ? PROCEDURE_TYPES.FIRST_INSTANCE
          : PROCEDURE_TYPES.APPEAL,
        props.mission.judiciaryProcessId,
      );
      props.requestGetJudgementAdd(
        props.mission?.claimId,
        props.mission?.step == 1
          ? PROCEDURE_TYPES.FIRST_INSTANCE
          : PROCEDURE_TYPES.APPEAL,
        props.mission.judiciaryProcessId,
      );
    }
  }, []);
  useDeepCompareEffect(() => {
    if (!isEmpty(props.expertiseVictim)) {
      setAllConsultinExpertise([...props.expertiseVictim] as any);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.expertiseVictim]);

  const filtredVictim = props.mission?.missionVictim?.find(
    (element: any) => element?.victimId === get(victim, 'id'),
  );
  const assignementId = props.mission?.assignedExperts?.find(
    (element: any) => element?.expertCode === props.sagis_code,
  )?.id;
  const thirdPartyAppealsItems = useSelector((state: any) =>
    get(state.toJS(), ['appContainer', 'listings', 'thirdPartyAppeals'], []),
  );
  const judiciaryExpertise = useSelector((state: any) =>
    get(state.toJS(), ['lawyerJudgement', 'expertiseRaport'], []),
  );
  const listings = useSelector((state: any) =>
    get(state.toJS(), ['appContainer', 'listings'], []),
  );
  const pretiumDolorisItems = useSelector((state: any) =>
    get(state.toJS(), ['appContainer', 'listings', 'pretiumDoloris'], []),
  );

  const aestheticDamageWithoutConsequenceItems = useSelector((state: any) =>
    get(
      state.toJS(),
      ['appContainer', 'listings', 'aestheticDamageWithoutConsequence'],
      [],
    ),
  );

  const aestheticDamageWithConsequenceItems = useSelector((state: any) =>
    get(
      state.toJS(),
      ['appContainer', 'listings', 'aestheticDamageWithConsequence'],
      [],
    ),
  );
  const careerPrejudiceItems = useSelector((state: any) =>
    get(state.toJS(), ['appContainer', 'listings', 'careerPrejudice'], []),
  );

  const schoolingPrejudiceItems = useSelector((state: any) =>
    get(state.toJS(), ['appContainer', 'listings', 'schoolingPrejudice'], []),
  );
  const judgementAddDocuments = get(
    useSelector((state: any) =>
      get(state.toJS(), ['lawyerJudgement', 'judgementAdd'], []),
    ),
    'judgementAddDocuments',
    [],
  );

  const filtredJudiciaryExpertise =
    !isEmpty(judiciaryExpertise) &&
    (judiciaryExpertise?.victimExpertises?.filter(
      (element: any) =>
        element.expertiseId !==
          renderFilterExpertiseTypeByMissionExpertise(props.mission?.type) &&
        element.victimId === get(victim, 'id'),
    ) ||
      judiciaryExpertise?.vehiculeExpertises?.filter(
        (element: any) => element.vehiculeId === get(vehicle, 'id'),
      ));

  const concernedJudiciaryExpertise = {
    ...judiciaryExpertise,
    victimExpertises: judiciaryExpertise?.victimExpertises?.filter(
      (element: any) =>
        element.expertiseId !==
          renderFilterExpertiseTypeByMissionExpertise(props.mission?.type) &&
        element.victimId === get(victim, 'id'),
    ),
    vehiculeExpertises: judiciaryExpertise?.vehiculeExpertises?.filter(
      (element: any) => element.vehiculeId === get(vehicle, 'id'),
    ),
  };

  const handleRenderIntialState = () => {
    const reportToRemove = allConsultinExpertise.filter(
      (el: any) => el.createdBy !== String(props.sagis_code),
    );
    setConsultingExpertise(null);
    setAllConsultinExpertise(reportToRemove);
  };

  const filtredJaddDocs = judgementAddDocuments?.map((el: any) => ({
    ...el,
    expertises: el?.expertises?.map((item: any) => ({
      ...item,
      vehicules: item.vehicules.filter(
        (it: any) => it.id === get(vehicle, 'id'),
      ),
      victims: item.victims.filter((it: any) => it.id === get(victim, 'id')),
    })),
  }));

  const concernedJudgementAddDocuments = filtredJaddDocs?.map(
    (element: any) => ({
      ...element,
      expertises: element?.expertises?.filter(
        (el: any) =>
          el.expertiseId !==
            renderFilterExpertiseTypeByMissionExpertise(props.mission?.type) &&
          !isEmpty(
            renderFilterConcernedPartyTypeByMissionExpertise(
              props.mission?.type,
              el.vehicules,
              vehicle,
              el.victims,
              victim,
            ),
          ),
      ),
    }),
  );
  const assignement = get(props.mission, 'assignedExperts', [])?.find(
    (element: any) => element.expertCode === props.sagis_code,
  );
  const labels = !isEmpty(filtredJudiciaryExpertise)
    ? [
        translate(messages.consultingReport, props),
        translate(messages.noticeDeficiency, props),
        translate(messages.postponementsExpertise, props),
        translate(messages.judiciaryExpertiseReport, props),
      ]
    : [
        translate(messages.consultingReport, props),
        translate(messages.noticeDeficiency, props),
        translate(messages.postponementsExpertise, props),
      ];
  let content;
  if (consultingExpertise !== null || !isEmpty(allConsultinExpertise))
    content = (
      <>
        {!isEmpty(allConsultinExpertise) &&
          allConsultinExpertise.map((element: any, index: any) => (
            <>
              {get(element, 'id', null) ? (
                <Recap
                  victim={victim}
                  mission={props.mission}
                  expertiseVictim={element}
                  vehicle={vehicle}
                  claimNumber={props.claimNumber}
                  lossDate={props.lossDate}
                  sagis_code={props.sagis_code}
                  index={index}
                  consultingExpertise={consultingExpertise}
                  setAllConsultinExpertise={setAllConsultinExpertise}
                  allConsultinExperise={allConsultinExpertise}
                  thirdPartyAppealsItems={configToItems(thirdPartyAppealsItems)}
                  pretiumDolorisItems={configToItems(pretiumDolorisItems)}
                  aestheticDamageWithoutConsequenceItems={configToItems(
                    aestheticDamageWithoutConsequenceItems,
                  )}
                  aestheticDamageWithConsequenceItems={configToItems(
                    aestheticDamageWithConsequenceItems,
                  )}
                  careerPrejudiceItems={configToItems(careerPrejudiceItems)}
                  schoolingPrejudiceItems={configToItems(
                    schoolingPrejudiceItems,
                  )}
                  listings={listings}
                  requestGetDocByDocumentumId={
                    props.requestGetDocByDocumentumId
                  }
                />
              ) : (
                <ConcernedExpertiseForm
                  victim={victim}
                  requestCreateVictimExpertise={
                    props.requestCreateVictimExpertise
                  }
                  vehicle={vehicle}
                  mission={props.mission}
                  expertiseVictim={element}
                  sagis_code={props.sagis_code}
                  index={index}
                  consultingExpertise={consultingExpertise}
                  setAllConsultinExpertise={setAllConsultinExpertise}
                  allConsultinExperise={allConsultinExpertise}
                  thirdPartyAppealsItems={configToItems(thirdPartyAppealsItems)}
                  pretiumDolorisItems={configToItems(pretiumDolorisItems)}
                  aestheticDamageWithoutConsequenceItems={configToItems(
                    aestheticDamageWithoutConsequenceItems,
                  )}
                  aestheticDamageWithConsequenceItems={configToItems(
                    aestheticDamageWithConsequenceItems,
                  )}
                  careerPrejudiceItems={configToItems(careerPrejudiceItems)}
                  schoolingPrejudiceItems={configToItems(
                    schoolingPrejudiceItems,
                  )}
                  listings={listings}
                  handleRenderIntialState={handleRenderIntialState}
                  requestGetDocByDocumentumId={
                    props.requestGetDocByDocumentumId
                  }
                  claimNumber={props.claimNumber}
                  lossDate={props.lossDate}
                />
              )}
            </>
          ))}
      </>
    );
  else if (
    !isEmpty(
      props.missionPostPone?.filter(
        (el: any) => el.missionPostPone.createdBy === props.sagis_code,
      ),
    )
  )
    content = (
      <Content>
        <ExpertiseIcon width="200" height="200" />
        <h3>{translate(messages.noExpertiseAdded, props)}</h3>
      </Content>
    );
  else
    content = (
      <Content>
        <ExpertiseIcon width="200" height="200" />
        <h3>{translate(messages.noExpertiseAdded, props)}</h3>
        <PrimaryButton
          title={translate(messages.addExpertise, props)}
          onClick={() => {
            setConsultingExpertise({} as any);
            (allConsultinExpertise as any).push({
              ...cloneDeep(EXPERTISE_INIT_STATE),
              status: MISSION_EXPERISE_VICTIM_STATUS.PENDING,
              missionVictimId: get(filtredVictim, 'id'),
              missionId: props.mission?.id,
              claimId: props.mission?.claimId,
              createdBy: props.sagis_code,
            } as any);
            setAllConsultinExpertise([...allConsultinExpertise]);
          }}
          background={BUTTON_COLORS.PRIMARY_BLUE}
          border={BUTTON_COLORS.PRIMARY_BLUE}
          titlecolor={BUTTON_COLORS.BLUE_BUTTON_TITLE}
        />
        <RefuseButton
          title={translate(messages.doesNotConcernMe, props)}
          onClick={() => setOpenRejectMissionDialog(true)}
        />
      </Content>
    );

  return (
    <Container>
      <LegalProceedingTabs labels={labels} currentTabIndex={currentTabIndex}>
        <>{content}</>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <RecapNoticeDeficiency
              title={translate({ ...messages.noticeDeficiency }, props)}
              missionPostPone={props.missionPostPone}
              isManager={false}
              requestUpdateMissionPostPone={props.requestUpdateMissionPostPone}
              uploadDocument={props.uploadDocument}
              uploadedDocument={
                (props.uploadedDocument as unknown) as IUploadedDocument
              }
              resetUploadedDocument={props.resetUploadDocumentStore}
              sagis_code={props.sagis_code}
              missionPostPoneExpertise={props.missionPostPoneExpertise}
              requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
            />
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <RecapPostPoneExpertise
              title={translate({ ...messages.postponementsExpertise }, props)}
              missionPostPoneExpertise={props.missionPostPoneExpertise}
              isManager={false}
              requestUpdateMissionPostPone={props.requestUpdateMissionPostPone}
              uploadDocument={props.uploadDocument}
              uploadedDocument={
                (props.uploadedDocument as unknown) as IUploadedDocument
              }
              resetUploadedDocument={props.resetUploadDocumentStore}
              sagis_code={props.sagis_code}
              requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
            />
          </Grid>
        </Grid>
        <JudiciaryExpertise
          judgementAddDocuments={concernedJudgementAddDocuments}
          listings={listings}
          uploadDocument={props.uploadDocument}
          uploadedDocument={props.uploadedDocument}
          resetUploadedDocument={() => {}}
          documentId={''}
          setDocumentId={() => {}}
          requestCreateExpertiseRaport={() => {}}
          claimId={props.mission?.claimId}
          claimNumber={''}
          requestGetExpertiseRaport={() => {}}
          expertiseReport={concernedJudiciaryExpertise}
          judiciaryProcessId={props.mission?.judiciaryProcessId}
          requestAddExpertiseSupportDocument={() => {}}
          requestValidateExpertReport={() => {}}
          currentJudiciaryProcess={{}}
          isAssignedLawyer={false}
          sagisVictimInfo={props.sagisVictimInfo}
          sagisOpposingParties={props.sagisOpposingParties}
          requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
        />
      </LegalProceedingTabs>
      <StyledDiv
        style={{
          top:
            featureService.hasFeature(FEATURES.TRANSACTION) &&
            get(props.mission, 'nature', null) === MISSION_NATURE.TRANSACTION
              ? '419px'
              : '333px',
        }}
      >
        {shouldDisplayActionButton(allConsultinExpertise, props.sagis_code) &&
          isEmpty(
            props.missionPostPone?.filter(
              (el: any) => el.missionPostPone.createdBy === props.sagis_code,
            ),
          ) && (
            <ActionButton
              setDropDown={setDropDown}
              dropDown={dropDown}
              isAppreciation={
                assignement?.type === MISSION_EXPERTISE_VICTIM_TYPE.APPRECIATION
              }
              isTransaction={
                featureService.hasFeature(FEATURES.TRANSACTION) &&
                get(props.mission, 'nature', null) ===
                  MISSION_NATURE.TRANSACTION
              }
              handleCreateReport={() => {
                setConsultingExpertise({} as any);
                (allConsultinExpertise as any).push({
                  ...cloneDeep(EXPERTISE_INIT_STATE),
                  status: MISSION_EXPERISE_VICTIM_STATUS.PENDING,
                  missionVictimId: get(filtredVictim, 'id'),
                  missionId: props.mission?.id,
                  claimId: props.mission?.claimId,
                  createdBy: props.sagis_code,
                } as any);
                setAllConsultinExpertise([...allConsultinExpertise]);
              }}
              handleCreateNoticeDeficiency={() =>
                setOpenNoticeDeficiencyDialog(true)
              }
              handleCreatePostPonement={() =>
                setOpenPostPoneExpertiseDialog(true)
              }
              displayButtonCreateRapport={
                !isEmpty(
                  props.missionPostPone?.filter(
                    (el: any) =>
                      el.missionPostPone.createdBy === props.sagis_code,
                  ),
                )
              }
            />
          )}
      </StyledDiv>
      <NoticeDeficiencyDialog
        open={openNoticeDeficiencyDialog}
        onClose={() => setOpenNoticeDeficiencyDialog(false)}
        validateDialog={props.requestCreateMissionPostPone}
        uploadDocument={props.uploadDocument}
        uploadedDocument={
          (props.uploadedDocument as unknown) as IUploadedDocument
        }
        mission={props.mission}
        missionPostPoneExpertise={props.missionPostPoneExpertise}
        resetUploadedDocument={props.resetUploadDocumentStore}
        recap={{}}
        listings={listings}
      />
      <PostPoneExpertise
        open={openPostPoneExpertiseDialog}
        onClose={() => setOpenPostPoneExpertiseDialog(false)}
        validateDialog={props.requestCreateMissionPostPone}
        uploadDocument={props.uploadDocument}
        uploadedDocument={
          (props.uploadedDocument as unknown) as IUploadedDocument
        }
        missionId={props.mission?.id}
        resetUploadedDocument={props.resetUploadDocumentStore}
        recap={{}}
        missionDate={props.mission?.missionDate}
      />
      <RejectMissionDialog
        open={openRejectMissionDialog}
        onClose={() => setOpenRejectMissionDialog(false)}
        validateDialog={props.requestRejectMission}
        assignementId={assignementId}
        claimId={props.mission?.claimId}
        missionId={props.mission?.id}
      />
    </Container>
  );
};

const mapStateToProps = createStructuredSelector({
  uploadedDocument: makeSelectDocument(),
  documentIdStore: makeSelectDocumentId(),
});
const mapDispatchToProps = {
  uploadDocument,
  resetUploadDocumentStore,
  requestCreateMissionPostPone,
  requestUpdateMissionExpertise,
  requestUpdateMissionPostPone,
  requestRejectMission,
  requestGetExpertiseRaport,
  requestGetJudgementAdd,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(ConcernedExpertise));
